import React from 'react';
import {
  BrowserRouter as Router, Route, Switch as Routes,
} from 'react-router-dom';
import { makeStyles } from '@eagleview/ev-comp-library';
import SignUp from './features/sign-up';
import Success from './features/success';
import Activated from './features/activated';
import Footer from './commonComponents/footer';

const useStyles = makeStyles(() => ({
  app: {
    height: '100vh',
    display: 'flex',
    flexFlow: 'column',
    backgroundColor: '#F0F2F7',
    '@media print': {
      height: 'fit-content !important',
    },
  },
}));

const App = () => {
  const classes = useStyles();
  return (
    <>
      <Router>
        <div className={classes.app}>
          <Routes>
            <Route path="/" exact>
              <SignUp />
              <Footer />
            </Route>
            <Route path="/registered">
              <Success />
              <Footer />
            </Route>
            <Route path="/activated">
              <Activated />
              <Footer />
            </Route>
          </Routes>
        </div>
      </Router>
    </>
  );
};

export default App;
